import { useNode } from "@craftjs/core";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";

import { SwitchInput } from "@/components/shared/forms";

import type { VideoGridProps } from "../video-grid-component";

export const AdvancedSettings = () => {
  const { t } = useTranslation();
  const {
    props,
    actions: { setProp },
  } = useNode((query) => ({
    props: query.props as VideoGridProps,
  }));

  const handleEnableToggle = useCallback(
    (
      toggleName: keyof Pick<
        VideoGridProps,
        "videoTitleEnabled" | "paginationEnabled" | "singleRowEnabled"
      >
    ) => {
      setProp((props) => {
        props[toggleName] =
          props[toggleName] === undefined ? true : !props[toggleName];
      });
    },
    [setProp]
  );

  return (
    <div className="grid gap-2">
      <span className="text-sm font-medium leading-6">
        {t("preference-panel.advanced-settings")}
      </span>

      <SwitchInput
        label={t("preference-panel.video-grid-enable-video-title")}
        data-testid="toggle-video-title"
        checked={Boolean(props.videoTitleEnabled)}
        onChange={() => {
          handleEnableToggle("videoTitleEnabled");
        }}
      />
    </div>
  );
};
